export default __webpack_public_path__ + "static/media/164.0ef13936.png";